import React from 'react';

const Spinner = () => {
  return (
    <div className='spinner' id='loader'>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default Spinner;
